// src/pages/Success.jsx
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setValue } from '../store/paymentSlice';
import { loadStripe } from '@stripe/stripe-js';

const key: string = process.env.REACT_APP_STRIPE_KEY_DEV as string
const Success = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('session_id');
    
    if (!sessionId) {
      return <></>;
    }


  dispatch(setValue(true))
  setTimeout(() => {
    navigate('/')
  }, 2000)
    return (
    <div className="flex items-center justify-center h-screen bg-green-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-green-700">We got your payment!</h1>
        <p className="mt-4 text-lg">The download should start within seconds. Youll be redirect within 5 seconds</p>
      </div>
    </div>
  );
};

export default Success;
